module.exports = __webpack_public_path__ + "static/media/read.00ef99d5.svg";